import { render } from "./ModulePluzzView.vue?vue&type=template&id=e18b5e4e"
import script from "./ModulePluzzView.vue?vue&type=script&lang=js"
export * from "./ModulePluzzView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__